[
  {
    "title": "2025 - Vor 50 Jahren: Die Ermordung Pasolinis",
    "subtitle": [
      "Eine Gemeinschaftsveranstaltung mit der Deutsch-Italienischen Gesellschaft e.V., Düsseldorf"
    ],
    "bodycopy": [
      "Kurzer Vortrag von Dr. Thomas Brückner (Privatdozent) : Würdigung Pasolinis und Einführung in den Film UCCELLACCI E UCCELLINI. Anschließend"
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "UCCELLACCI E UCCELLINI",
        "director": "Pier Paolo Pasolini",
        "country": "Italia",
        "releaseYear": 1965,
        "runtime": 85,
        "version": "OmU",
        "screeningDate": "20.11.2025",
        "readableDate": "2025-11-20",
        "screeningTime": "21:30",
        "actors": "Totò, Ninetto Davoli,·Femi Benussi, Rossana Di Rocco, Lena Lin Solaro",
        "subtitle": [
          "Pier Paolo Pasolinis \"Uccellacci e uccellini\" ist ein kraftvoller und poetischer Film, der die Zerbrechlichkeit und Schönheit der Natur sowie die komplexen Beziehungen zwischen Lebewesen erkundet. Mit seiner typischen Mischung aus sozialkritischer Tiefe und ästhetischer Raffinesse zeigt Pasolini eine Welt, in der Vögel als Symbole für Freiheit, Sehnsucht und Vergänglichkeit stehen."
        ],
        "bodycopy": [
          "Ein Vater und sein Sohn gehen über eine öde Landstraße durch eine eher eintönige Landschaft. Zu ihnen gesellt sich ein philosophierender Rabe. Und im Wechsel zwischen Verbildlichung seiner Fabeln, phantastischer Realisierung der Erzählungen des Vaters sowie dessen Episoden entsteht ein nachdenklicher und dennoch unterhaltsamer Film."
        ],
        "image": "../../uccellacci e uccellini.jpg"
      }
    ]
  },
  {
    "title": "",
    "subtitle": [""],
    "bodycopy": [""],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "ENNIO (ENNIO MORRICONE - DER MAESTRO)",
        "director": "Giuseppe Tornatore",
        "country": "Italien",
        "releaseYear": 2022,
        "runtime": 156,
        "version": "OmU",
        "screeningDate": "03.06.2023",
        "readableDate": "2023-06-03",
        "screeningTime": "20:00",
        "actors": "",
        "subtitle": [
          "Eröffnungsfilm der Reihe SPOTLIGHT ON ENNIO MORRICONE in der Black Box. Anschl. Umtrunk und Imbiss."
        ],
        "bodycopy": [
          "Giuseppe Tornatore schuf mit ENNIO ein Denkmal für Ennio Morricone, den wohl bekanntesten und erfolgreichsten Filmkomponisten des 20. Jahrhunderts. Bekannt wurde er mit SPIEL MIR DAS LIED VOM TOD auch heute noch verbinden viele seinen Namen mit den Italo-Western, für die er viele Filmmusiken geschrieben hat. In einer spannenden Szenen Folge über das Leben und Werk Morricones montiert Tornatore Interviews mit dem „Maestro“ und anderen Musikern zusammen mit Beobachtungen von Filmemachern, die mit ihm zusammengearbeitet haben. Glanzpunkte des Films sind bisher unbekannte Zeugnisse aus Morricones Leben, sowie Originalaufnahmen von ihm beim Arbeiten an seiner Musik und bei Konzerten. Dieses Material stammt zum Teil aus Privatarchiven, an das Tonatore nur kam, weil er mit Morricone und seiner Familie befreundet war. Ein Film, der nicht nur Musikfreunde begeistern wird. C’era una volta il West – Spiel mir das Lied vom Tod (Fr. 09.06.2023–21.00 Uhr), Il federale –Die Helden machen Überstunden (Fr. 09.06.2023–21.00 Uhr), Uccellacci e uccellini – Große Vögel, kleine Vögel (So. 11.06.2023–15:00 Uhr), Queimada – Queimada – Insel des Schreckens (So. 18.06.2023–17:15 Uhr), Peur sur la ville – Angst über der Stadt (Fr. 25.06.2023–18:30 Uhr), Una pura formalità – Eine reine Formalität (So. 25.06.2023–15:00 Uhr), The Mission – Mission (Do. 29.06.2023–20.00 Uhr)."
        ],
        "image": "../Ennio.jpg"
      }
    ]
  },
  {
    "title": "",
    "subtitle": [""],
    "bodycopy": [""],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "MAMMA ROMA",
        "director": "Pier Paolo Pasolini",
        "country": "Italien",
        "releaseYear": 1962,
        "runtime": 105,
        "version": "OmU",
        "screeningDate": "14.01.2023",
        "readableDate": "2023-01-14",
        "screeningTime": "21:00",
        "actors": "Anna Magnani, Ettore Garofolo, Franco Citti, Silvana Corsini u.a.",
        "subtitle": [
          " Die Restaurierung von MAMMA ROMA wurde 2022 durch das Centro Sperimentale di Cinematografia Cineteca Nazionale aus den Bildnegativen und dem Soundtrack durchgeführt, die von RTI-Mediaset in Zusammenarbeit mit Infinity+ und Cine 34 zur Verfügung gestellt wurden. Um eine vollständige Version des Films zu erstellen, wurden einige Teile, die in den Bildnegativen fehlten oder beschädigt waren, mit einem in der Cineteca Nazionale konservierten Positiv kombiniert. "
        ],
        "bodycopy": [
          "Mamma Roma versucht ihre Vergangenheit hinter sich zu lassen. Carmine, ihr Zuhälter und Vater ihres Kindes, heiratet eine andere Frau. Ein neues Leben steht auf der Tagesordnung. Mamma Roma zieht mit ihrem 16-jährigen Sohn, der auf dem Land in einem Internat aufgewachsen ist, in eine bürgerliche Gegend und betreibt einen Gemüsestand. Das neue gemeinsame Leben entpuppt sich als äußerst spannungsgeladen und plötzlich ist Carmine zurück, inzwischen von seiner neuen Frau getrennt. Er stellt Mamma Roma vor ein Ultimatum.",
          "„Es gibt in diesem Film Augenblicke von bestürzender Schönheit, die gleich neben Bildern des Untergangs stehen, mehr noch, die aus diesem wachsen und wieder in ihn zurückfließen. Als Ettore nach einem schäbigen Diebstahl und einem Selbstmordversuch in der Psychiatrie landet, rezitiert einer der Mit-Insassen aus Dantes „Inferno“. Kurz darauf erklingt Vivaldi. Man muss das im Kino erleben, um zu glauben, dass dieser Moment nicht in Kitsch umkippt.“ (Claus Löser) "
        ],
        "image": "../mamma-roma-1.jpg"
      },
      {
        "title": "GRUPPO DI FAMIGLIA IN UN INTERNO (GEWALT UND LEIDENSCHAFT)",
        "director": "Luchino Visconti",
        "country": "Italien/Frankreich",
        "releaseYear": 1974,
        "runtime": 121,
        "version": "OmU",
        "screeningDate": "22.01.2022",
        "readableDate": "2022-01-22",
        "screeningTime": "19:00",
        "actors": "Burt Lancaster, Helmut Berger, Silvana Mangano u.a.",
        "subtitle": [
          "Eine Kooperation des Teams „Neu restauriert“ mit dem „Italienischen Filmclub“ (beide Filmmuseum)",
          "In einem prachtvollen Haus mit einer in die Jahre gekommenen Ausstattung lebt ein alter Professor, zurückgezogen und allein mit seinen Gemälden, Bildern, Büchern, Kunstgegenständen und Erinnerungen. Er hat sich mit den Jahren immer weiter isoliert, vermietet jedoch widerwillig die in seinem Palazzo leerstehende Wohnung. Die jungen Bewohner*innen konfrontieren ihn mit einer aufwühlenden, modernen Welt stellen damit seine Ruhe und Zurückgezogenheit infrage. Insbesondere mit dem jungen Konrad, einem ehemaligen „1968er“, freundete er sich in einem väterlichen Verhältnis an."
        ],
        "bodycopy": [
          "„Es ist die Geschichte eines Intellektuellen. Durch den Kontakt mit einer Gruppe junger Leute voller Vitalität und Unvernunft, die nur daran interessiert sind, alles das wegzufegen, was vor ihnen da war, bekommt der alte Mann das ganze Gewicht seiner Einsamkeit zu spüren.“ (Luchino Visconti)",
          "Die Ausstattung spielt in dem Film eine entscheidende Rolle. Visconti zeichnet das Familienbild mit penibler Genauigkeit, als würde er ein Gemälde im Stil des 18. Jahrhunderts malen. Detailverliebtheit und Präzision sind in jeder Einstellung zu spüren.",
          "Die Restaurierung des Films entstand 2013 im Centro sperimentale di Cinematografia – Cineteca Nazionale, Rom."
        ],
        "image": "../gewalt-und-leidenschaft.jpg"
      }
    ]
  },
  {
    "title": "2020 - Ciao Aracà",
    "subtitle": [
      "Als Gast in der Black Box: Daniel Chisholm, der Regisseur und Autor von CIAO ARACÀ"
    ],
    "bodycopy": [
      "Erneut im Programm, da die Veranstaltung im 1. HJ wegen des Corona Virus ausgefallen ist."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "Ciao Aracà (Ciao Aracà)",
        "director": "Daniel Chisholm",
        "country": "Deutschland",
        "releaseYear": 2019,
        "runtime": 63,
        "version": "OmU",
        "screeningDate": "17.09.2020",
        "readableDate": "2020-09-17",
        "screeningTime": "20:00",
        "actors": "Es treten auf: ehemalige und aktuelle Bewohner von Aracà",
        "subtitle": [
          "Ein Dorf in Italien steht am Rande des Verfalls, aber seine alternden Einwohner treten ihrer Zukunft mutig entgegen, während die nächste Generation um das Überleben im ländlichen Kontext kämpft."
        ],
        "bodycopy": [
          "Aracà, ein Dorf in den ligurischen Bergen, ist in Bewegung. Alternde Landwirte und ihre Familien müssen eine Vielzahl schwieriger Probleme angehen: Der Verlust traditioneller Anbaumethoden, globalisierte Agrarmärkte, eine Abwanderung junger Menschen und ein Zustrom von Außenstehenden, die billige Immobilien aufkaufen. Trotz dieser existenziellen Herausforderungen begegnen sie der Zukunft mit Anmut, Würde, Stoizismus und einem schelmischen Sinn für Humor.",
          "Gleichzeitig suchen ihre verbliebenen Nachkommen nach Möglichkeiten, den Niedergang des ländlichen Raums aufzuhalten, indem sie in neue Weinreben, Geräte zur Weinherstellung, die Verjüngung von Olivenhainen, die neuesten landwirtschaftlichen Maschinen und eine bessere Vermarktung investieren. Obwohl sie erkannt haben, dass Qualität und Herkunft von grundlegender Bedeutung sind, bleiben ihre Erfolgschancen ungewiss.",
          "CIAO ARACÀ dokumentiert das Leben der Bauern und ihrer Familien. Mit Sorgfalt und Einfühlungsvermögen werden die Kämpfe einer kleinen Gemeinde mit Industrialisierung und Globalisierung beleuchtet, ohne die ebenfalls vorhandenen Perspektiven aus den Augen zu verlieren."
        ],
        "image": "../ciaoaraca.png"
      },
      {
        "title": "Il Decameron (Dekameron)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien",
        "releaseYear": 1971,
        "runtime": 112,
        "version": "OmenU",
        "screeningDate": "01.03.2011",
        "readableDate": "2011-03-01",
        "screeningTime": "20:00",
        "actors": "Franco Citti, Ninetto Davoli, Jovan Jovanović, Angela Luce, Pier Paolo Pasolini, Giuseppe Zigaina, Vincenzo Amato, Guido Alberti, Giacomo Rizzo, Monique van Vooren, Elisabetta Genovese, Silvana Mangano",
        "subtitle": [
          "Eine Kooperation der Deutsch-Italienischen Gesellschaft e.V. – Dante Alighieri _ Düsseldorf mit dem Italienischen Filmclub",
          "IL DECAMERON bildet zusammen mit I RACCONTI DI CANTERBURY und IL FIORE DELLE MILLE E UNA NOTTE Pasolinis Trilogie des Lebens.  Für diese werden drei strukturell ähnliche literarische Werke aus unterschiedlichen Epochen und Kulturkreisen vereinigt, um unterhaltsam wesentlichen existenziellen Fragen des Individuums und seiner Rolle in der Gesellschaft nachzugehen."
        ],
        "bodycopy": [
          "Inspiriert von Boccaccios Novellensammlung thematisiert Pasolini in IL DECAMERON mit acht Geschichten die menschliche Geschlechtlichkeit und Sinnesfreude in einer düsteren archaischen Welt. Das Leben der einfachen Leute ist ständig bedroht durch überall lauernde Gewalt und ihre Lebensfreude bricht sich Bahn in sexueller Triebbefriedigung",
          "Abweichend von Boccaccios Rahmenhandlung mit Pestflüchtigen, die sich Geschichten erzählen, präsentiert Pasolini die acht Episoden in der Figur eines Schülers von Giotto.",
          "Begleitet wird der Film durch einen Einführungsvortrag der Kunst- und Filmwissenschaftlerin Donatella Chiancone-Schneider: IL DECAMERON wird unter kunst- und filmhistorischen Aspekten erläutert, im Kontext der Filmografie Pasolinis vorgestellt und mit seinen literarischen und malerischen Vorlagen verglichen."
        ],
        "image": "../ildecameron.jpg"
      }
    ]
  },
  {
    "title": "2020 - IL GATTOPARDO - DER LEOPARD",
    "subtitle": [
      "In Zusammenarbeit mit der Deutsch-Italienischen-Gesellschaft e.V. / Società Italo-Tedesca e.V. – Dante Alighieri - Düsseldorf"
    ],
    "bodycopy": [
      "Begleitveranstaltung zum Lesemarathon am 6. März 2020 im NRW Literaturbüro e.V.(Gerhard-Hauptmann-Haus): Tommasi di Lampedusa „Il Gattopardo“"
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "Il Gattopardo (Der Leopard)",
        "director": "Luchino Visconti",
        "country": "Italien/Frankreich",
        "releaseYear": 1963,
        "runtime": 180,
        "version": "OmU",
        "screeningDate": "08.03.2020",
        "readableDate": "2020-03-08",
        "screeningTime": "16:00",
        "actors": "Burt Lancaster, Claudia Cardinale, Alain Delon, Paolo Stoppa u.a.",
        "subtitle": [
          " Schon bald nach seinem Erscheinen 1958 zählte Tomasi di Lampedusas „Il Gattopardo“, der von den gesellschaftlichen Umbrüchen des 19. Jahrhunderts berichtet, zur Weltliteratur. Bereits vier Jahre später,1962, hatte Luchino Visconti aus dem Romanstoff einen Film geschaffen, der fester Teil der Filmgeschichte ist. Er erzählt die Geschichte des Übergangs von der feudalen zur bürgerlichen Macht mit filmischen Mitteln; in Bildern von blühender Pracht und morbidem Glanz."
        ],
        "bodycopy": [
          "Der alternde Fürst Don Fabrizio, Principe di Salina (Burt Lancaster), sieht die Erosion der Macht der Adelsgeschlechter kommen und verweigert die Mitarbeit am neuen Königreich Italien. Gleichzeitig fördert er die Eheschließung seines Neffen Tancredi (Alain Delon) mit Angelica (Claudia Cardinale), der Tochter des Bürgermeisters. Visconti inszeniert das Zusammentreffen der alten und neuen Gesellschaft in einem großen Ball, dessen Choreographie unvergesslich ist. Mit kritischer Sympathie folgt der Film der letzten Lebensphase des Fürsten. Legendär ist der Satz des Romans, mit dem Tancredi seinem Onkel den Wandel der Zeitenläufe erklärt: „Es muss sich alles ändern, damit es bleibt, wie es ist.“",
          "„Ein bewegendes historisches und gesellschaftliches Panoramabild von faszinierender Schönheit und analytischer Schärfe“ (Lexikon des Internationalen Films)"
        ],
        "image": "../Il gattopardo.jpg"
      }
    ]
  },
  {
    "title": "2019 - ORECCHIE, OHRENSAUSEN",
    "subtitle": [
      "Zu Gast In der Black Box: ALESSANDRO ARONADIO mit seinem Film ORECCHIE - OHRENSAUSEN"
    ],
    "bodycopy": [
      "Das Schaffen von Alessandro Aronadio hat viele Seiten: Die Verdoppelung im Filmwerk von Cronenberg war das Abschlussthema im Psychologiestudium des 1975 in Rom geborenen Filmkünstlers. Seitdem arbeitet er als Fotograf und mit Preisen ausgezeichneter Schriftsteller, hauptsächlich aber als Regieassistent für zahlreiche Spiel-, Dokumentar- und Fernsehfilme. Seine eigenen Kurzfilme und Videoclips erhielten mehrfach Preise. In den bisherigen drei Spielfilmen tritt seine Virtuosität zu Tage: DUE VITE PER CASO erweitert auf den Spuren Kieslowskis und Tykwers die Auseinandersetzung mit dem Thema Zufall und in ORECCHIE erfindet er eine neue schwarz-weiße Bildsprache für das Genre Komödie. Sein dritter Film DIO C’È verpackt eine intellektuelle Auseinandersetzung mit den Weltreligionen in eine Commedia all’Italiana. Alle Filme behandeln Fragen der menschlichen Existenz, die mit visueller Phantasie, Tiefgang und Leichtigkeit erzählt werden."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "Orecchie (Ohrensausen)",
        "director": "Alessandro Aronadio",
        "country": "Italia",
        "releaseYear": 2016,
        "runtime": 90,
        "version": "OmU",
        "screeningDate": "31.10.2019",
        "readableDate": "2019-10-31",
        "screeningTime": "20:00",
        "actors": "Daniele Parisi, Silvia D'Amico, Rocco Papaleo, Pamela Villoresi, Ivan Franek, Piera Degli Esposti, Milena Vukotic, Paolo Giovannucci, Andrea Purgatori, Massimo Wertmüller, Francesca Antonelli, Niccolò Senni, Masaria Colucci, Silvana Bosi, Sonia Gessner",
        "subtitle": [
          "In Schwarz-Weiss gedreht, behandelt diese Komödie beiläufig existenzielle Fragen in einer Aufeinanderfolge augenzwinkernder, skurriler und absurder Situationen. Eine strenge Fotografie und ein fast akademischer Bildaufbau schaffen dazu eine Ernsthaftigkeit vermittelnde Kontrastfolie.",
          "In Zusammenarbeit mit dem Italienischen Kulturinstitut Köln.",
          "Mit der freundlicher Unterstützung des Hotel Orangerie, Düsseldorf."
        ],
        "bodycopy": [
          "Er wird morgens mit einem Pfeifen im Ohr wach ... und es den ganzen Film über nicht mehr los. Am Kühlschrank findet Er einen Zettel „Dein Freund Luigi ist tot.“ Wer aber ist dieser Luigi? Das ist der Start in einen tragikomischen Tag mit sadistischen Ärzten, aufdringlichen Nonnen, einem Hip-Hop-Star im abgefahrenen Ambiente, der Frage, wie Er seiner Verlobten ein Lächeln entlocken kann, und der Begegnung mit der Mutter, die mit einem „Performance“-Künstler ihren neuen Frühling durchlebt. Und da ist immer wieder dieser Luigi, an den er sich beim besten Willen nicht erinnern kann."
        ],
        "image": "../orecchie-5.jpg"
      }
    ]
  },
  {
    "title": "2018 - LA CICCIOLINA. GÖTTLICHE SKANDALNUDEL",
    "subtitle": ["Begrüßung: Joachim Manzin", "Moderation: Daniela Bacchini"],
    "bodycopy": [
      "Alessandro Melazzini ist ein Künstler des Zeitgeschehens in Bild und Wort: Als gebürtiger Italiener mit Wohnsitz in Deutschland greift er als Dokumentarfilmer Themen beider Länder auf und arbeitet publizistisch für italienische und deutsche Tageszeitungen (u.a. Il Sole und Süddeutsche Zeitung). Er versteht sich als Mittler zwischen den Kulturen beider Ländern und sucht in Veranstaltungen den Kontakt mit dem Publikum. Bei diesem Besuch in Düsseldorf bringt er seinen letzten, für ARTE produzierten Film mit: LA CICCIOLINA. GÖTTLICHE SKANDALNUDEL."
    ],
    "extra": {
      "text": "",
      "links": [
        {
          "label": "",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "LA CICCIOLINA. GÖTTLICHE SKANDALNUDEL",
        "director": "Alessandro Melazzini",
        "country": "Deutschland/Frankreich",
        "releaseYear": 2016,
        "runtime": 54,
        "version": "OmU",
        "screeningDate": "05.12.2018",
        "readableDate": "2018-12-05",
        "screeningTime": "20:00",
        "actors": "Ilona Staller (Cicciolina), Michele Lo Foco, Filippo Ceccarelli, Marco Gregoretti, Gianfranco Spadaccia, Jeff Koons",
        "subtitle": [""],
        "bodycopy": [
          "Entlang der Biographie Ilona Stallers wird das Phänomen der von ihr verkörperten Pornostarikone Cicciolina beleuchtet. In Ungarn 1951 geboren ebnete eine Hochzeit ihren Weg nach Italien, wo sie sich in den 70er Jahren schnell zur Sex-Pop-Ikone entwickelte. Ihren Ruhm und ihren Ruf nutzte sie, um 1987 als Abgeordnete für die Partito Radicale ins Italienische Parlament einzuziehen. Das sorgte für ungeheures internatonales Aufsehen und veränderte den Umgang in der italienischen Politik. Dabei waren Cicciolinas Gesetzesinitiative nicht provokant, sondern eher konstruktiv (Tierschutz, Umweltschutz, Situation von Häftlingen u.ä.). Über einen geschäftlichen Kontakt lernte sie Jeff Koons kennen, den sie heiratete, mit ihm einen Sohn zeugte und ihn zu vom Kunstmarkt teuer bezahlten Kunstwerken inspirierte.. Nach dem Scheitern der nur kurzen Ehe und ihrem Abschied aus der Pornobranche  ist sie international politisch tätig.",
          "Zum Abschluss wirft der Film die Frage auf, ob Cicciolina durch die Fixierung des Wahlkampfs auf ihre Person und ihre Showtalente die Wahrnehmung der Politiker in der Öffentlichkeit so verändert hat, dass der Weg für den Entertainer und Medienexperten Berlusconi frei wurde."
        ],
        "image": "../la-cicciolina.jpg"
      }
    ]
  },
  {
    "title": "2016 - ITALIENISCHER FILMCLUB SPEZIAL: WESTERN ALL’ITALIANA",
    "subtitle": [""],
    "bodycopy": [
      "Django, Sabata, Sartana. Jeder Kinogänger kennt die Filmfiguren des Italowestern, die an diese Blütezeit des italienischen Kinos erinnern. In den Werken von Quentin Tarantino, Robert Rodriguez oder John Woo wirkt diese Epoche der Filmgeschichte auch heute noch fort. Der italienische Filmclub spürt mit vier ausgewählten Filmen diesem Genre nach."
    ],
    "extra": {
      "text": "",
      "links": [
        {
          "label": "",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "CIPOLLA COLT (ZWIEBEL-JACK RÄUMT AUF)",
        "director": "Enzo G. Castellari (als Enzo Girolami)",
        "country": "Italien/Spanien/Deutschland",
        "releaseYear": 1975,
        "runtime": 91,
        "version": "OmU",
        "screeningDate": "25.09.2016",
        "readableDate": "2016-09-25",
        "screeningTime": "16:30",
        "actors": " Franco Nero, Sterling Hayden, Martin Balsam, Emma Cohen, Leo Anchóriz, Romano Puppo",
        "subtitle": [""],
        "bodycopy": [
          "In dieser parodistischen Western-Komödie legt sich Franco Nero (Django) als Zwiebelfarmer mit einem Ölmagnaten an, der ihm nach Land und Leben trachtet. Elemente der Commedia dell’arte und der Commedia all’italiana verbinden sich mit der Slapstick-Tradition. Der Film ironisiert die vorausgegangene Phase der Klamaukfilme des Genres."
        ],
        "image": "../cipolla-colt-1.jpg"
      },
      {
        "title": "DJANGO",
        "director": "Sergio Corbucci",
        "country": "Italien/Spanien",
        "releaseYear": 1966,
        "runtime": 91,
        "version": "OmU",
        "screeningDate": "15.09.2016",
        "readableDate": "2016-09-15",
        "screeningTime": "20:00",
        "actors": "Franco Nero, José Canalejas, José Bódalo, Loredana Nusciak, Ángel Álvarez, Gino Pernice, Simón Arriaga, Giovanni Ivan Scratuglia",
        "subtitle": [""],
        "bodycopy": [
          "In den Kampf zweier Banditenbanden mischt sich ein Fremder ein, der ein Maschinengewehr in einem Sarg hinter sich herzieht: Django. „Der eigentümlich konstruierte, überaus spannende und brutale Italowestern erwies sich als ein so überragender kommerzieller Erfolg, dass er eine wahre Django-Flut auslöste.“ (Filmdienst)In den Kampf zweier Banditenbanden mischt sich ein Fremder ein, der ein Maschinengewehr in einem Sarg hinter sich herzieht: Django. „Der eigentümlich konstruierte, überaus spannende und brutale Italowestern erwies sich als ein so überragender kommerzieller Erfolg, dass er eine wahre Django-Flut auslöste.“ (Filmdienst)"
        ],
        "image": "../django-2.jpg"
      },
      {
        "title": "FACCIA A FACCIA (VON ANGESICHT ZU ANGESICHT)",
        "director": "Sergio Sollima",
        "country": "Italien/Spanien",
        "releaseYear": 1967,
        "runtime": 112,
        "version": "OmU",
        "screeningDate": "03.09.2016",
        "readableDate": "2016-09-03",
        "screeningTime": "19:00",
        "actors": "Gian Maria Volontè, Tomas Milian, William Berger, Jolanda Modio, Gianni Rizzo, Carole André, Ángel del Pozo",
        "subtitle": [""],
        "bodycopy": [
          "Ein Duell der anderen Art: der vom Banditen Bennet als Geisel genommene Fletcher findet immer mehr Gefallen am kriminellen Leben, während der Verbrecher auf den rechten Weg zurück findet. FACCIA A FACCIA ist nach RESA DEI CONTI der zweite Teil von Sollimas Western-Trilogie und gilt als einer der tiefgründigsten Italo-Western. So wirft er u.a. Fragen zur Relativität moralischer Fragen im kriminellen Umfeld auf."
        ],
        "image": "../faccia-a-faccia-2.jpg"
      },
      {
        "title": "LA RESA DEI CONTI (DER GEHETZTE DER SIERRA MADRE)",
        "director": "Sergio Sollima",
        "country": "Italien/Spanien",
        "releaseYear": 1966,
        "runtime": 110,
        "version": "OmU",
        "screeningDate": "02.09.2016",
        "readableDate": "2016-09-02",
        "screeningTime": "21:15",
        "actors": "Lee Van Cleef, Tomas Milian, Walter Barnes, Nieves Navarro, Gérard Herter, Maria Granada, Roberto Camardiel, Ángel del Pozo, Luisa Rivelli",
        "subtitle": [""],
        "bodycopy": [
          "Der Kopfgeldjäger Corbett wird auf den vermeintlichen Mädchenmörder Cuchillo angesetzt. Als er diesen nach einigen Widrigkeiten findet, begreift er dessen Unschuld und beide suchen den wahren Täter. Die spannende Geschichte, beeindruckende Darsteller und die hervorragenden Landschaftsaufnahmen machen diesen Film zu einem der großen Klassiker des Genres. Der berühmte Soundtrack – von Quentin Tarantino 2009 in INGLORIOUS BASTERDS wiederverwendet – stammt von Ennio Morricone."
        ],
        "image": "../la-resa-dei-conti.jpg"
      }
    ]
  },
  {
    "title": "2015 - FRANCO MARESCO - BELLUSCONE – WARUM DIE ITALIENER BERLUSCONI LIEBEN",
    "subtitle": [
      "Der sizilianische Regisseur Franco Maresco hat seine Anwesenheit in Düsseldorf wegen Krankheit leider absagen müssen."
    ],
    "bodycopy": [
      "Anlass ist die Präsentation des Buches über sein gemeinsames Kinoschaffen mit Daniele Ciprì und die Vorstellung seines letzten Films.",
      "Buchvorstellung Sieglinde Borvitz CONTROCORRENTE – DIE KRUDEN VISIONEN VON CIPRÌ UND MARESCO. Nach der These dieses Buches legen die beiden Regisseure die Mechanismen der medialen „Gouvernementalität“ in Italien offen, indem sie einen semiotischen Konflikt befeuern, der die politische Aufteilung des Sinnlichen, also unsere Wahrnehmung, betrifft.",
      "Die Veranstaltung ist Teil des öffentlichen Seminars „Die Neuverhandlung des Imaginären. Tendenzen des aktuellen italienischen Kinos“ der Universität Heinrich Heine, das am 6. und 7. Juli 2015 im „Haus der Universität“ in Düsseldorf (Schadowplatz 14) stattfindet."
    ],
    "extra": {
      "text": "",
      "links": [
        {
          "label": "",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "BELLUSCONE. UNA STORIA SICILIANA (BELLUSCONE - WARUM DIE ITALIENER BERLUSCONI LIEBEN)",
        "director": "Franco Maresco",
        "country": "Italien",
        "releaseYear": 2014,
        "runtime": 95,
        "version": "OmU",
        "screeningDate": "06.07.2015",
        "readableDate": "2015-07-06",
        "screeningTime": "20:00",
        "actors": "",
        "subtitle": [""],
        "bodycopy": [
          "Es sind Marescos schräge Protagonisten, die Berlusconi, in Sizilien nur „Belluscone“ genannt, seine Stimmen sichern. Die Straßen Palermos erscheinen in den Bildern Marescos als mafiöse Parallelwelt, in der eine Hand die andere wäscht – und aus der es kein Entrinnen gibt. Maresco macht in erschreckender Weise deutlich, wie das System der Mafia im Kleinen funktioniert."
        ],
        "image": "../belluscone.jpg"
      }
    ]
  },
  {
    "title": "2015 - UNA VITA TRANQUILLA (EIN RUHIGES LEBEN)",
    "subtitle": [
      "18.00 Uhr - Laura Garavini spricht über das deutsch-italienische Verhältnis, die Mafia und Europa und lädt zum Diskutieren ein."
    ],
    "bodycopy": [
      "Zur Person:",
      "Laura Garavini wurde am 23. Juli 1966 in Vignola (MO) geboren und lebt seit 1989 in Deutschland und Italien. 2007 gründete sie mit prominenten italienischen Gastronomen in Berlin die Initiative „Mafia? Nein danke!“. 2008 wurde sie als Vertreterin der Auslandsitaliener in die italienische Abgeordnetenkammer gewählt und war vom November 2008 bis März 2013 Fraktionsvorsitzende des Partito Democratico im Antimafia-Ausschuss des italienischen Parlaments. 2013 kandidierte sie erneut erfolgreich im Wahlkreis Europa. und wurde im März 2014 zur Vorsitzenden der „Kommission zur Bekämpfung der organisierten Kriminalität auf europäischer und internationaler Ebene” ernannt. Gegenwärtig ist sie auch Vorsitzende der deutsch-italienischen Parlamentariergruppe."
    ],
    "extra": {
      "text": "Eine Sonderveranstaltung des Italienischen Filmclubs in Zusammenarbeit mit der Deutsch-Italienischen Gesellschaft e.V. Dante Aligheri.",
      "links": [
        {
          "label": "",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "UNA VITA TRANQUILLA (EIN RUHIGES LEBEN - DIe Mafia vergisst nicht)",
        "director": "Claudio Cupellini",
        "country": "Italien/Deutschlanf/Frankreich",
        "releaseYear": 2010,
        "runtime": 105,
        "version": "OmU",
        "screeningDate": "16.05.2013",
        "readableDate": "2013-05-16",
        "screeningTime": "20:00",
        "actors": "Toni Servillo, Marco D'Amore, Francesco Di Leva, Juliane Köhler, Maurizio Donadoni, Alice Dwyer, Leonardo Sprengler",
        "subtitle": [""],
        "bodycopy": [
          "Toni Servillo erhielt auf dem Filmfestival Rom mit Recht die Auszeichnung als bester männlicher Darsteller für seine Rolle als ausgestiegener Mafiosi, der als Restaurantbesitzer und Ehemann einer deutschen Frau unerwartet von seiner Vergangenheit eingeholt wird."
        ],
        "image": "../una-vita-tranquilla.jpg"
      }
    ]
  },
  {
    "title": "2015 - IL CARATTERE ITALIANO. LA STORIA DI UNA GRANDE ORCHESTRA ITALIANA. (DIE ITALIENISCHE ART. DIE GESCHICHTE EINES GROßEN ITALIENISCHEN ORCHESTERS.)",
    "subtitle": [
      "18.00 Uhr - Laura Garavini spricht über das deutsch-italienische Verhältnis, die Mafia und Europa und lädt zum Diskutieren ein."
    ],
    "bodycopy": [
      "Die italienische Art: ein Film über Musik, ein Film in der Musik."
    ],
    "extra": {
      "text": "Eine Sonderveranstaltung des Italienischen Filmclubs in Zusammenarbeit mit der Deutsch-Italienischen Gesellschaft e.V. Dante Aligheri.",
      "links": [
        {
          "label": "",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "IL CARATTERE ITALIANO. LA STORIA DI UNA GRANDE ORCHESTRA ITALIANA. (DIE ITALIENISCHE ART. DIE GESCHICHTE EINES GROßEN ITALIENISCHEN ORCHESTERS)",
        "director": "Angelo Bozzolini",
        "country": "Deutschland/Italien",
        "releaseYear": 2013,
        "runtime": 100,
        "version": "OmU",
        "screeningDate": "01.03.2015",
        "readableDate": "2015-03-01",
        "screeningTime": "12:00",
        "actors": null,
        "subtitle": [""],
        "bodycopy": [
          "Das Orchestra dell'Accademia Nazionale di Santa Cecilia spielt am 3.3.2015 in der Tonhalle Düsseldorf. Zur Einstimmung zeigen wir diesen Dokumentarfilm über die Geschichte des Orchesters, dessen Mitglieder und ihre Musik.",
          "Mit aktuellen Aufnahmen und Archivschätzen wird ein Porträt des Orchesters gezeichnet. Der Film lässt den Zuschauer miterleben, wie eine Aufführung entsteht. Er lernt die Musiker und ihre Musik kennen, fiebert mit ihnen der Aufführung entgegen und erlebt die Erleichterung und Freude nach dem Schlussapplaus."
        ],
        "image": "../die-italienische-art.jpg"
      }
    ]
  },
  {
    "title": "2014 - LA MEGLIO GIOVENTÙ (DIE BESTEN JAHRE)",
    "subtitle": [
      "10 Jahre „Italienischer Filmclub“ in der Black Box – Kino im Filmmuseum Düsseldorf: wenn das kein Grund zum Feiern ist!"
    ],
    "bodycopy": [
      "Als alles begann, wurde den Initiatoren Marisa und Joachim Manzin prophezeit: „Das haltet Ihr keine drei Jahre durch!“ Manchmal helfen schlechte Vorhersagen, um das Gegenteil zu bewirken. Und so schauen wir in unserem regelmäßigen Programm zurück auf die Höhepunkte der letzten 10 Jahre. LINK",
      "Feiern aber wollen wir dieses Jubiläum an einem Wochenende mit einem monumentalen, sechstündigen Film der neueren Zeit, der nichts geringeres versucht, als 40 Jahre Zeitgeschichte Italiens zu erzählen, von der Aufbruchzeit der 60er Jahre bis zur Stagnation im Produktionsjahr des Films 2003.",
      "Eine Pause mit spanisch inspiriertem Meeresfrüchterisotto, sowie Wein, alkoholfreien Getränken u.a. (gesponsert von „Manzin, italienische Übersetzungen“) ermöglicht ein Atemholen, Füßevertreten und interessante Gespräche."
    ],
    "extra": {
      "text": "",
      "links": [
        {
          "label": "",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "La meglio gioventù (Die besten Jahre)",
        "director": "Marco Tullio Giordana",
        "country": "Italien",
        "releaseYear": 2003,
        "runtime": 366,
        "version": "OmU",
        "screeningDate": "21.05.2005",
        "readableDate": "2005-05-21",
        "screeningTime": "17:00",
        "actors": "Alessio Boni, Luigi Lo Cascio, Jasmine Trinca, Adriana Asti, Sonia Bergamasco, Fabrizio Gifuni, Maya Sansa, Camilla Filippi, Valentina Carnelutti",
        "subtitle": ["Werkschau: Luigi Lo Cascio"],
        "bodycopy": [
          "Die Geschichte der Familie Carati von 1966 bis heute vor dem Hintergrund einer politisch aufregenden Zeit in Italien. Fast beiläufig vollziehen sich die Ereignisse und dennoch hinterlassen sie unmerklich tiefe Spuren in den handelnden Personen.Die Geschichte der Familie Carati von 1966 bis heute vor dem Hintergrund einer politisch aufregenden Zeit in Italien. Fast beiläufig vollziehen sich die Ereignisse und dennoch hinterlassen sie unmerklich tiefe Spuren in den handelnden Personen.Der Erfolg bei Festivals und beim Publikum brachte diesen für das Fernsehen produzierten und dort nicht gezeigten Film in die Kinosäle und auf diesem Umweg auch auf die heimischen Bildschirme."
        ],
        "image": "../la-meglio-gioventu-1.png"
      }
    ]
  },
  {
    "title": "2012 - Puccini e la fanciulla",
    "subtitle": [""],
    "bodycopy": [
      "Am 16. September 2012 ist der italienische Regisseur Paolo Benvenuti zusammen mit Paola Baroni zu Gast in der Black Box. In Italien ist Paolo Benvenuti bekannt für seine außergewöhnliche Erzählweise und Bildsprache mit historisch-kulturellem Hintergrund."
    ],
    "extra": {
      "text": "",
      "links": [
        {
          "label": "",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "Puccini e la fanciulla",
        "director": "Paolo Benvenuti, Paola Baroni",
        "country": "Italien",
        "releaseYear": 2009,
        "runtime": 78,
        "version": "S",
        "screeningDate": "16.09.2012",
        "readableDate": "2012-09-16",
        "screeningTime": "20:00",
        "actors": "Riccardo Moretti, Tania Squiliano, Giovanna Daddi, Debora Mattiello, Federica Chezzi",
        "subtitle": ["Ohne Dialoge"],
        "bodycopy": [
          "Während Puccini seine Oper „La fanciulla del West“ komponiert, verfangen sich die Personen in seiner Umgebung in sexuellen Intrigen und Beziehungen. Das beeinflusst auch Puccini und seinen Schaffensprozess."
        ],
        "image": "../puccini-e-la-fanciulla.jpg"
      }
    ]
  },
  {
    "title": "2011 - Retrospektive Pier Paolo Pasolini",
    "subtitle": [""],
    "bodycopy": [
      "Im Februar und März 2011 zeigen der Filmclub 813 Köln und der Filmmuseum Düsseldorf (Black Box) sämtliche Kurz- und Spielfilme von Pier Paolo Pasolini, dessen Ermordung sich am 2. November 2010 zum 35. Mal jährte. Mit Ausnahmen von SALÒ O LE 120 GIORNATE DI SODOMA (Di e120 Tage von Sodom), die wir schon am 15.04.2010, ore 20:00, gezeigt haben."
    ],
    "extra": {
      "text": "",
      "links": [
        {
          "label": "",
          "link": ""
        }
      ]
    },
    "movies": [
      {
        "title": "Le mura di Sana’a (Die Mauer von Sana’a)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien",
        "releaseYear": 1971,
        "runtime": 14,
        "version": "OmU",
        "screeningDate": "27.02.2011",
        "readableDate": "2011-02-27",
        "screeningTime": "15:00",
        "actors": "",
        "subtitle": [""],
        "bodycopy": [
          "Dokumentation „in Form eines Appells an die UNESCO“ über die bedrohten historischen Bauten in der jemenitischen Hauptstadt Sana‘a, die der Drehort für eine aus der endgültigen Fassung von IL DECAMERON herausgeschnittenen Sequenz war."
        ],
        "image": "../le mura di sana.jpg"
      },
      {
        "title": "Appunti di viaggio per un film sull'India (Notizen für einen Film über Indien)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien",
        "releaseYear": 1968,
        "runtime": 35,
        "version": "OmU",
        "screeningDate": "14.03.2011",
        "readableDate": "2011-03-14",
        "screeningTime": "20:00",
        "actors": "Pier Paolo Pasolini",
        "subtitle": ["Mit: Pier Paolo Pasolini"],
        "bodycopy": [
          "Ein Reisetagebuch, die Schilderung des Versuchs, einen Film nach einer Legende aus der indischen Mythenwelt zu drehen: die Geschichte eines Maharadschas, der seinen Körper den vom Hungertod bedrohten Tigerjungen hingibt. Pasolini interviewt repräsentative Personen aus den verschiedenen gesellschaftlichen Gruppierungen."
        ],
        "image": "../Appunti.jpg"
      },
      {
        "title": "Il fiore delle Mille e una notte (Erotische Geschichten aus 1001 Nacht)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien",
        "releaseYear": 1974,
        "runtime": 129,
        "version": "OmU",
        "screeningDate": "05.03.2011",
        "readableDate": "2011-03-05",
        "screeningTime": "20:00",
        "actors": "Ninetto Davoli, Franco Citti, Franco Merli, Tessa Bouché, Ines Pellegrini, Margaret Clementi, Luigina Rocchi, Alberto Argentino, Francesco Paolo Governale, Salvatore Sapienza, Franca Sciutto",
        "subtitle": ["Mit: Pier Paolo Pasolini"],
        "bodycopy": [
          "Von den drei Filmen der „Trilogie des Lebens“ ist dies der gelungenste. Der Reigen erotischer Abenteuer gipfelt immer wieder in Nacktheiten und Geschlechtlichkeiten, die wirklich ahnen lassen, was Pasolini als Ausdruck einer „Freude des Lebens“ vorgeschwebt haben mag."
        ],
        "image": "../il fiore.jpg"
      },
      {
        "title": "I racconti di Canterbury (Pasolinis tolldreiste Geschichten)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien/Frankreich",
        "releaseYear": 1972,
        "runtime": 110,
        "version": "OmU",
        "screeningDate": "04.03.2011",
        "readableDate": "2011-03-04",
        "screeningTime": "20:00",
        "actors": "Hugh Griffith, Laura Betti, Ninetto Davoli, Franco Citti, Josephine Chaplin, Alan Webb, Pier Paolo Pasolini, Vernon Dobtcheff, Adrian Street, Michael Balfour, Jenny Runacre, Tom Baker",
        "subtitle": [""],
        "bodycopy": [
          "Das ist sozusagen der zweite Teil von Pasolinis Verfilmung der deftigsten Geschichten mittelalterlicher Weltliteratur. Wieder die gleiche Saftigkeit wie in seinem Film DECAMERON. Pasolini malt das mit viel Geschmack am derben Ungeschmack aus."
        ],
        "image": "../I racconti di Canterbury.jpg"
      },
      {
        "title": "IL DECAMERON (DECAMERON)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien",
        "releaseYear": 1971,
        "runtime": 116,
        "version": "OmU",
        "screeningDate": "05.10.2022",
        "readableDate": "2022-10-05",
        "screeningTime": "19:00",
        "actors": "Franco Citti, Ninetto Davoli, Jovan Jovanović, Angela Luce, Pier Paolo Pasolini, Giuseppe Zigaina, Vincenzo Amato, Guido Alberti, Giacomo Rizzo, Monique van Vooren, Elisabetta Genovese, Silvana Mangano",
        "subtitle": [""],
        "bodycopy": [
          "Leute, die der Allegorie fernstehen, so heißt es, haben diesmal sein Interesse gefesselt, haben seine Aufmerksamkeit auf die temperamentgeladene süditalienische Ursprünglichkeit gelenkt, die er in furioser Komödiantik sich austoben lässt."
        ],
        "image": "../ildecameron.jpg"
      },
      {
        "title": "Medea (Medea)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien/Deutschland/Frankreich",
        "releaseYear": 1969,
        "runtime": 110,
        "version": "OmU",
        "screeningDate": "27.01.2021",
        "readableDate": "2021-01-27",
        "screeningTime": "20:00",
        "actors": "Maria Callas, Massimo GIrotti, Laurent Terzeiff, Giuseppe Gentile, ;argareth Clémenti, Gerard Weiss, Sergio Tramonti, Luigi Barbini, Anna Maria Chio",
        "subtitle": [""],
        "bodycopy": [
          "Pasolinis Absicht ist klar: keinen weiteren Klassiker aus dem Geist humanistischer Verlogenheit zu inszenieren, sondern ein ethnologisches Drama der Kulturkonfrontation."
        ],
        "image": "../Medea.jpg"
      },
      {
        "title": "Il porcile (Der Schweinestall)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien/Frankreich",
        "releaseYear": 1969,
        "runtime": 99,
        "version": "OmU",
        "screeningDate": "23.02.2011",
        "readableDate": "2011-02-23",
        "screeningTime": "20:00",
        "actors": "Pierre Clémenti, Jean-Pierre Léaud, Alberto Lionello, Ugo Tognazzi, Marco Ferreri, Anne Wiazemsk<, Ninetto Davoli",
        "subtitle": [""],
        "bodycopy": [
          "Eine Attacke auf unsere Konsumgesellschaft in abgründigen Gleichnissen: Pasolini entwickelt eine für ihn neue, fratzenhafte Komik, über deren Giftigkeit einem das Lachen vergeht."
        ],
        "image": "../Il porcile.jpg"
      },
      {
        "title": "Appunti per un'Orestiade africana (Notizen für eine afrikanische Orestie)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien",
        "releaseYear": 1970,
        "runtime": 65,
        "version": "OmU",
        "screeningDate": "27.02.2011",
        "readableDate": "2011-02-27",
        "screeningTime": "15:00",
        "actors": "Pier Paolo Pasolini, Gato Barbieri, Marcelli Melis",
        "subtitle": [""],
        "bodycopy": [
          "Der Versuch einer Transposition der ORESTIE des Aischylos in das moderne Afrika. Auf der Suche nach möglichen Drehorten und Figuren führt Pasolini ein filmisches Notizbuch."
        ],
        "image": "../Orestiade.jpg"
      },
      {
        "title": "Uccellacci e uccellini (Große Vögel, kleine Vögel)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien",
        "releaseYear": 1966,
        "runtime": 88,
        "version": "OmU",
        "screeningDate": "19.02.2011",
        "readableDate": "2011-02-19",
        "screeningTime": "20:00",
        "actors": "Totò, Ninetto Davoli, Femi Benussi, Umberto Bevilacqua, Renato Capogna, Alfredo Leggi, Renato Montalbano, Flaminia Siciliano, Giovanni Tarallo, Vittorio Vittori, Domenico Modugno, Gabriele Baldini",
        "subtitle": [""],
        "bodycopy": [
          "Vater und Sohn sind unterwegs. Wohin, bleibt unklar. Sie werden begleitet von einem sprechenden Raben, der ihnen die Welt erklärt, der doziert, bis sie ihn kurzerhand verspeisen und alleine weiterziehen. Der Stil der Inszenierung und Montage ist ein Kompendium filmsprachlicher Möglichkeiten."
        ],
        "image": "../uccellacci e uccellini.jpg"
      },
      {
        "title": "Il Vangelo secondo Matteo (Das erste Evangelium - Matthäus)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien/Frankreich",
        "releaseYear": 1964,
        "runtime": 131,
        "version": "OmU",
        "screeningDate": "18.02.2011",
        "readableDate": "2011-02-18",
        "screeningTime": "20:00",
        "actors": "Enrique Irazoqui, Margherita Caruso, Susanna Pasolini, Marcello Morante, Rossana di Rocco, Mario Socrate, Alessandro Chierici",
        "subtitle": [""],
        "bodycopy": [
          "Pasolini filmt das Matthäus-Evangelium als gälte es, einen neorealistischen Film über den Mezzogiorno zu drehen. Er unterschlägt weder den sozial-revolutionären noch den religiösen Gehalt des Evangeliums."
        ],
        "image": "../Il Vangelo.jpg"
      },
      {
        "title": "Sopralluoghi in Palestina (Motivsuche in Palästina)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien",
        "releaseYear": 1965,
        "runtime": 55,
        "version": "OmU",
        "screeningDate": "14.03.2011",
        "readableDate": "2011-03-14",
        "screeningTime": "20:00",
        "actors": "Pier Paolo Pasolini, Adrea Carraro",
        "subtitle": [""],
        "bodycopy": [
          "Damit er historische Orte für den Film Das erste Evangelium - Matthäus rekonstruieren kann, reiste Pasolini nach Israel, um die notwendigen Untersuchungen anzustellen. Dies ist ein Rechenschaftsbericht, geschrieben mit der Kamera."
        ],
        "image": "../sopralluoghi.jpg"
      },
      {
        "title": "La rabbia (Der Zorn)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien",
        "releaseYear": 1963,
        "runtime": 53,
        "version": "OmU",
        "screeningDate": "09.03.2011",
        "readableDate": "2011-03-09",
        "screeningTime": "18:00",
        "actors": "Giorgio Bassani, Renato Guttuso",
        "subtitle": [""],
        "bodycopy": [
          "Ein Montagefilm mit der Wut oder dem Zorn Pasolinis. Einem Zorn gegen die bürgerliche Welt, Barbarei und Intoleranz, gegen Vorurteile und Banalität. Ein außerordentliches Dokument, das implizit ein weiteres Mal die Autonomie der Schöpfung, der Poesie, der Kultur bewies."
        ],
        "image": "../la_rabbia.jpg"
      },
      {
        "title": "La ricotta (Der Weichkäse)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien/Frankreich",
        "releaseYear": 1963,
        "runtime": 35,
        "version": "OmU",
        "screeningDate": "09.03.2011",
        "readableDate": "2011-03-09",
        "screeningTime": "18:00",
        "actors": "Orson Wells, Mario Cipriani, Laura Betti, Edmonda Aldini, Vittorio La Paglia, Maria Bernardini",
        "subtitle": [""],
        "bodycopy": [
          "La RICOTTA ist eine Episode des Films RoGoPaG, dessen andere Episoden von Roberto Rossellini, Jean-Luc Godard und Ugo Gregoretti gedreht worden sind. Pasolini hat ein Ensemble von Figuren versammelt, die es ihm erlaubt, auf engstem Raum ein Universum satirischer Kritik, sarkastischen Humors und ästhetisch-politischer Definition zu entwickeln"
        ],
        "image": "../la ricotta.jpg"
      },
      {
        "title": "Accattone (Wer nie sein Brot mit Tränen aß)",
        "director": "Pier Paolo Pasolini",
        "country": "Italien",
        "releaseYear": 1961,
        "runtime": 116,
        "version": "OmU",
        "screeningDate": "04.02.2011",
        "readableDate": "2011-02-04",
        "screeningTime": "20:00",
        "actors": "Franco Citti, Franca Pasut, Silvana Corsini, Adele Cmbria, Paola Guidi, Adriana Asti",
        "subtitle": [""],
        "bodycopy": [
          "Mit ACCATONE beschreibt Pasolini die Welt erstmals mit und in der Sprache des Films. Dabei verwandelt er die Episodenstruktur des Neorealismus in die hermetische Geschlossenheit der Tragödie. Die Fabel des kleinen römischen Zuhälters Accatone wird als Passionsgeschichte mit den Mitteln des Kinos der Poesie erzählt."
        ],
        "image": "../accattone.jpg"
      }
    ]
  },
  {
    "title": "2010 - Cento giorni a Palermo (die 100 Tage von Palermo)",
    "subtitle": ["Zu Gast beim italienischen Filmclub: Giuseppe Ferrara"],
    "bodycopy": [
      "Im Rahmen einer öffentlichen Seminar-Veranstaltung der Heinrich-Heine-Universität ist der in Italien für seine politischen Filme berühmte Regisseur Giuseppe Ferrara (IL CASO ALDO MORO, GIOVANNI FALCONE) Gast einer Sonderveranstaltung des Italienischen Filmclubs in der Black Box. Soziales, politisches und künstlerisches Engagement begleitet das Leben Ferraras fast seit seiner Geburt 1932 in Castelfiorentino bei Florenz. Schon in der Schule fiel er durch seinen auf Widerstands gebürsteten Charakter auf, so dass er seine Abschlussprüfung außerhalb der Schule ablegen musste. Diese durch konstruktiven Widerstand geprägte Lebenshaltung begleitete und begleitet sein gesamtes Lebenswerk. Damit ist er ein typischer Vertreter des künstlerisch-kulturellen italienischen Universalintellektuellen seiner Generation. In Italien berühmt wurde er insbesondere in den 80er Jahren durch Filme, in denen er in dokumentarischer Art politische Ereignisse rekonstruierte, die Italien in ihren Grundfesten erschütterten. Von der italienischen Öffentlichkeit wenig stark wahrgenommen setzt er sich für die Ausbildung junger Filmkünstler ein und gestaltet Sendungen und Bücher zu Filmthemen. Auch seine letzten Filme reflektieren die dunkle Seite der italienischen Geschichte: die Bedeutung der Mafiafrauen, den Calvi-Skandal und die zweifelhafte Rolle der Brigate Rosse. "
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "Cento giorni a Palermo (Die 100 Tage von Palermo)",
        "director": "Giuseppe Ferrara",
        "country": "Italien/Frankreich",
        "releaseYear": 1983,
        "runtime": 93,
        "version": "S",
        "screeningDate": "11.06.2010",
        "readableDate": "2010-06-11",
        "screeningTime": "20:00",
        "actors": "Lino Ventura, Giuliana ",
        "subtitle": [""],
        "bodycopy": [
          "Der Film beschreibt das Bemühen des Generals Dalla Chiesa (LinoVentura), der trotz seiner Verdienste im Kampf gegen die Brigate Rosse von den Politikern in das Amt des Polizeichefs von Palermo gedrängt wird. Als dem Staat verpflichteter und in die Institutionen vertrauender Staatsbeamter nimmt er diese ihm ursprünglich fremde Rolle als Mafiaermittler an, muss aber im Laufe seiner mit Energie vorangetriebenen Ermittlungen feststellen, dass er immer mehr zwischen die Mühlräder verschiedener Interessen gerät und schließlich jeglichen Rückhalt zu verlieren droht."
        ],
        "image": "../cento-giorni-a-palermo.jpg"
      },
      {
        "title": "MÖRDERISCHE GESELLSCHAFTEN - Die Geschichte der Mafia",
        "director": "Bernhard Pfletschinger",
        "country": "Deutschland",
        "releaseYear": 2010,
        "runtime": 90,
        "version": "OmU",
        "screeningDate": "06.10.2021",
        "readableDate": "2021-10-06",
        "screeningTime": "20:00",
        "actors": "",
        "subtitle": [
          "Arte-Vorpremiere in Anwesenheit des Regisseurs und weiteren Gästen"
        ],
        "bodycopy": [
          "Die eine Mafia gibt es nicht – zu unterschiedliche sind die mafiösen Strukturen der kampanischen „Camorra“, der kalabresischen „`Ndrangheta“, sowie der sizilianischen „Cosa Nostra“ und ihrer jeweiligen Geschichte. Bernd Pfletschinger hat sich auf die Suche nach den Wurzeln und der Entwicklung der einzelnen Organisationen gemacht und zeigt, wie tief deren Organisation in der Geschichte Italiens und ihrer Bevölkerung verankert ist. Doch sind diekriminellen Machenschaften nicht auf Italien begrenzt, sondern internationalisieren sich zunehmend und werden damit zur Bedrohung für die Demokratien der Welt. In diesem Film kommen Historiker, Strafrichter und Angehörige von Opfern mit ihren Einsichten und Erinnerungen zu Wort und versuchen den unaufhaltsame Aufstieg und die fast grenzenlose Macht der Mafien zu erklären. Bernhard Pfletschinger wird seinen Film vorstellen und mit weiteren Gästen mit dem Publikum sprechen. Mit einem Umtrunk im Foyer wird er Abend ausklingen."
        ],
        "image": "../moerderische-gesellschaften.jpg"
      }
    ]
  },
  {
    "title": "2007 - Libera Terra",
    "subtitle": ["Weltpremiere"],
    "bodycopy": [
      "Veranstaltungstermin in Anwesenheit des Regisseurs Frank Wittlinger: 23. Juni 2007 - 19.30 Uhr. Anschließend Premierenfeier im Studio des Filmmuseums."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "Libera terra",
        "director": "Monica Colautti und Frank Wittlinger",
        "country": "Deutschland",
        "releaseYear": 2007,
        "runtime": 48,
        "version": "OmU",
        "screeningDate": "23.06.2007",
        "readableDate": "2007-06-23",
        "screeningTime": "19:30",
        "actors": "",
        "subtitle": [""],
        "bodycopy": [
          "Corleone – der Name steht spätestens seit Hollywood sich des Themas annahm für Mafia und Mafiaverbrechen. Corleone – der Ort, von dem aus der Boss der Bosse Bernardo Provenzano bis zur Verhaftung am 11. April 2006 vierzig Jahre lang seine Fäden spinnen konnte. Corleone – heute ein Ort, der mit seinen Nachbargemeinden die gegen die Mafia gerichtete Landwirtschaftskooperative „Placido Rizzotto - Libera Terra“ umgibt. Vor 10 Jahren hatte der Turiner Geistliche, Don Luigi Ciotti, die Idee, eine Kooperative zu initiieren, um die konfiszierten Mafia-Gutshöfe wieder ihrem ursprünglichen landwirtschaftlichen Nutzen zuzuführen. Dank des Engagements vieler Gruppen konnte vor 5 Jahren dieses Projekt verwirklicht werden und wird nach anfänglichen Schwierigkeiten heute von den Bewohnern akzeptiert und italienweit unterstützt. Die Mitglieder der Kooperative ließen sich weder durch massive Behinderungen noch durch Warnungen (zerstörte Saat, erhängter Hund auf dem Feld u.ä.) entmutigen. Der Film stellt die Kooperative und die Situation kurz nach der Verhaftung Provenzanos dar, lässt deren Mitglieder, die Bewohner und die Antimafiaaktivisten zu Wort kommen und zeigt dabei eine Mafia, die zwar im Film nicht erscheint, aber allgegenwärtig ist."
        ],
        "image": "../libera-terra-7.jpg"
      }
    ]
  },
  {
    "title": "2005 - Mario Adorf",
    "subtitle": ["Weltpremiere"],
    "bodycopy": [
      "Viele der italienischen Filme, in denen Mario Adorf mitgespielt hat, sind in Deutschland nur in der Synchronfassung und häufig nur im Fernsehen gezeigt worden. Daher sind nur wenige italienische Originalfassungen mit deutschen Untertiteln hergestellt worden.Um so mehr freuen wir uns, Ihnen die folgenden beiden Filme anläßlich der Mario-Adolf-Ausstellung im Filmmuseum Düsseldorf zeigen zu können."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "Milano Calibro 9 (Milano Kaliber 9)",
        "director": "Fernando di Leo",
        "country": "Italien",
        "releaseYear": 1972,
        "runtime": 98,
        "version": "OmU",
        "screeningDate": "14.12.2005",
        "readableDate": "2005-12-14",
        "screeningTime": "21:30",
        "actors": "Gastone Moschin, Barbara Bouchet, Mario Adorf, Frank Wolff, Luigi Pistilli, Ivo Garrani, Philippe Leroy, Lionel Stander",
        "subtitle": ["Werkschau: Mario Adorf"],
        "bodycopy": [
          "Einer der bedeutensten „Poliziotti“-Filme: Ugo Piazza hat eine dreijährige Haftstrafe beendet. Der „Amerikaner“ glaubt, er habe ihm 300.000 Dollar unterschlagen und setzt den skrupellosen Schläger Rocco Musco (Mario Adorf) auf ihn an. Aber nicht nur er ist hinter dem Geld her... Und so schlägt die Handlung immer wieder unerwartete Kapriolen.Ein modern fotografierter Film mit einer spannenden Filmmusik von Oscar-Preisträger Luis Enríquez Bacalov (\"Der Postmann\", \"Das erste Evangelium Matthäus\").Wir zeigen die vollständige Originalfassung. Die deutsche Synchronfassung wurde seinerzeit stark gekürzt."
        ],
        "image": "../calibro-9.jpg"
      },
      {
        "title": "Francesco (Franziskus)",
        "director": "Liliana Cavani",
        "country": "Italien/Deutschland",
        "releaseYear": 1989,
        "runtime": 130,
        "version": "OmU",
        "screeningDate": "20.12.2005",
        "readableDate": "2005-12-20",
        "screeningTime": "19:00",
        "actors": "Mickey Rourke, Helena Bonham Carter, Andréa Ferrèol, Nikolaus Dutsch, Peter Berling, Mario Adorf",
        "subtitle": ["Werkschau: Mario Adorf"],
        "bodycopy": [
          "Der Film erzählt die Geschichte des heiligen Franz von Assisi, des Gründers des Franziskaner-Ordens. Als Francesco Bernadone 1182 geboren verließ er unverstanden das wohlhabende Elternhaus und begab sich unter die Armen und Kranken, um mit ihnen zu leben. Lange ringt er um die Anerkennung seiner Bewegung durch den Vatikan. Nachdem er diese erhalten hat, verzweifelt er am Wunsch seiner Anhänger nach „Regeln“ und zieht auf der Suche nach Erleuchtung in die Wälder.Mario Adorf spielt eine Nebenrolle als Kardinal Ugolino Di Segni."
        ],
        "image": "../franziskus.jpg"
      }
    ]
  },
  {
    "title": "2004 - Con gli occhi di lei",
    "subtitle": ["Sechs italienische Regisseurinnen erzählen"],
    "bodycopy": [
      "Gibt es einen spezifischen weiblichen Blick auf das heutige Italien? Eine Reihe mit acht Filmen von sechs Regisseurinen will versuchen, diese Frage zu beantworten. Als besondere Attraktion wird die Regisseurin Wilma Labate ihren letzten Film vorstellen.",
      "Die vom italienischen Kulturinstitut Köln konzipierte Reihe kann durch die Zusammenarbeit mit dem Italienischen Filmclub, der Black Box, dem Filmmuseum in Düsseldorf und mit Unterstützung von Manzin, italienische Übersetzungen, auch in Düsseldorf gezeigt werden."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "La mia generazione (La mia generazione)",
        "director": "Wilma Labate",
        "country": "Italien",
        "releaseYear": 1996,
        "runtime": 95,
        "version": "OmU",
        "screeningDate": "26.04.2004",
        "readableDate": "2004-04-26",
        "screeningTime": "19:30",
        "actors": "Stefano Accorsi, Claudio Amendola, Francesca Neri",
        "subtitle": [""],
        "bodycopy": [
          "Braccio, ein politischer Gefangener, wird von einer Sonderhaftanstalt auf  Sizilien nach Mailand überführt. Sein anfängliches Misstrauen gegenüber dem Carabiniere, der ihn begleitet und menschlich behandelt, schwindet im Verlauf der Reise."
        ],
        "image": "../la mia generazione.jpg"
      },
      {
        "title": "Tano da morire (Oh Tano!)",
        "director": "Roberta Torre",
        "country": "Italien",
        "releaseYear": 1997,
        "runtime": 80,
        "version": "OmU",
        "screeningDate": "16.04.2004",
        "readableDate": "2004-04-16",
        "screeningTime": "19:30",
        "actors": "Andrea Di Stefano, Donatella Finocchiaro, Mario Pupella",
        "subtitle": [""],
        "bodycopy": [
          "Angela ist in Ballarò, dem Markt-Viertel Palermos auf­gewachsen. Mit zwanzig heiratet sie Saro. Das junge Pärchen schlägt sich mit Drogenhandel und schnel­len Geschäften durch. Als sie Masino begegnet, der zum rechten Arm ihres Mannes wird, beginnt sie mit ihm eine leiden­schaftliche Affäre."
        ],
        "image": "../Tano-da-morire.jpg"
      },
      {
        "title": "Angela (Angela)",
        "director": "Roberta Torre",
        "country": "Italien",
        "releaseYear": 2002,
        "runtime": 95,
        "version": "OmU",
        "screeningDate": "02.06.2004",
        "readableDate": "2004-06-02",
        "screeningTime": "19:30",
        "actors": " Andrea Di Stefano, Donatella Finocchiaro, Mario Pupella",
        "subtitle": [""],
        "bodycopy": [
          "Angela ist in Ballarò, dem Markt-Viertel Palermos auf­gewachsen. Mit zwanzig heiratet sie Saro. Das junge Pärchen schlägt sich mit Drogenhandel und schnel­len Geschäften durch. Als sie Masino begegnet, der zum rechten Arm ihres Mannes wird, beginnt sie mit ihm eine leiden­schaftliche Affäre."
        ],
        "image": "../Angela.jpg"
      },
      {
        "title": "Rose e pistole (Rosen und Pistolen)",
        "director": "Carla Apuzzo",
        "country": "Italien",
        "releaseYear": 1998,
        "runtime": 81,
        "version": "OmU",
        "screeningDate": "21.05.2004",
        "readableDate": "2004-05-21",
        "screeningTime": "19:30",
        "actors": "Anna Anunirati, Duccio Giordano, Luigi Petrucci",
        "subtitle": [""],
        "bodycopy": [
          "Zwischen Bagnoli und den Campi Flegrei sind Rosa und Angelo, zwei Zwanzigjährige, auf der Flucht vor ihrem Ehemann, denn der reiche Metzger Pappalardo hat einen Killer engagiert..."
        ],
        "image": "../rose-e-pistole.jpg"
      },
      {
        "title": "L’ inverno (Winter)",
        "director": "Nina Di Majo",
        "country": "Italien",
        "releaseYear": 2001,
        "runtime": 97,
        "version": "OmU",
        "screeningDate": "19.05.2004",
        "readableDate": "2004-05-19",
        "screeningTime": "19:30",
        "actors": "Valeria Bruni Tedeschi, Valeria Golino, Fabrizio Gifuni, Yorgo Voyagis, Paolo Paolini",
        "subtitle": [""],
        "bodycopy": [
          "In einer post-industriellen Metropole Norditaliens treffen zwei Paare aufeinander, die in ihrem Egoismus gefangen sind, unfähig, Beziehungen aufzubauen und zu kommunizieren."
        ],
        "image": "../L'inverno.jpg"
      },
      {
        "title": "Non è giusto (Es ist nicht fair)",
        "director": "Antonietta De Lillo",
        "country": "Italien",
        "releaseYear": 2001,
        "runtime": 102,
        "version": "OmU",
        "screeningDate": "14.05.2004",
        "readableDate": "2004-05-14",
        "screeningTime": "19:30",
        "actors": "Maddalena Polistina, Daniel Podromo, Antonio Manzini, Valerio Binasco",
        "subtitle": [""],
        "bodycopy": [
          "Valerio lebt bei seiner Mutter in Stockholm. Die Sommerfe­rien soll er bei seinem chaotischen Vater in Neapel verbringen, der ihm eine Afrikareise versprochen hat. Am Strand lernt er Sofia kennen. Ihre Eltern sind ebenfalls geschieden. Valerio und Sofia tauschen Erfahrungen, Beobachtungen und Hoffnungen aus. Langsam keimen erste Anzeichen erwa­chender Gefühle..."
        ],
        "image": "../non-e-giusto.jpg"
      },
      {
        "title": "Domenica (Domenica)",
        "director": "Wilma Labate",
        "country": "Italien",
        "releaseYear": 2001,
        "runtime": 95,
        "version": "OmU",
        "screeningDate": "28.04.2004",
        "readableDate": "2004-04-28",
        "screeningTime": "19:30",
        "actors": "Claudio Amendola, Annabella Sciorra, Domenica Giuliano, ",
        "subtitle": [""],
        "bodycopy": [
          "Ein Polizeikommissar und eine Waise laufen einen Tag lang durch die Straßen Neapels. In einem Wirrwarr flüchtiger Begebenheiten führt das Mädchen den Kommissar durch die Gassen eines armen, geheimnisvollen, unschuldigen und verfluchten Neapels."
        ],
        "image": "../Domenica.jpg"
      },
      {
        "title": "Domani (Der Tag danach)",
        "director": "Francesca Archibugi",
        "country": "Italien",
        "releaseYear": 2001,
        "runtime": 88,
        "version": "OmU",
        "screeningDate": "22.04.2004",
        "readableDate": "2004-04-22",
        "screeningTime": "19:30",
        "actors": "Marco Baliani, Ornella Muti, David Bracci, Valerio Mastandrea",
        "subtitle": [""],
        "bodycopy": [
          "Nach dem Erdbeben 1997 in Umbrien findet ein ganzes Dorf, nach anfänglichem Chaos, die Lust am Leben, die Gefühle und das Lachen wieder."
        ],
        "image": "../Domani.jpg"
      }
    ]
  },
  {
    "title": "2004 - Casomai (Trauen wir uns?!)",
    "subtitle": ["Premiere"],
    "bodycopy": [
      "Die Düsseldorfer Filmkunstkinos, die Black Box – Kino im Filmmuseum - und der Italienische Filmclub des Filmmuseums Düsseldorf präsentieren mit Unterstützung von Manzin Italienische Übersetzungen, die Deutschlandpremiere dieses schon in Italien erfolgreichen FIlms in Anwesenheit des Regisseurs und des Schauspielers RIno Manni, der im Film die Rolle des Priesters übernommen hat."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "CASOMAI (Trauen wir uns?!)I",
        "director": "Alessandro D'Alatri",
        "country": "Italien",
        "releaseYear": 2002,
        "runtime": 114,
        "version": "OmU",
        "screeningDate": "21.08.2004",
        "readableDate": "2004-08-21",
        "screeningTime": "19:30",
        "actors": " Stefania Rocca, Fabio Volo, Rino Manni, Sara D’Amario",
        "subtitle": [""],
        "bodycopy": [
          "Der Wunsch eines Paares und die unkonventionellen Ideen eines Priesters sind Gegenstand eines der ungewöhnlichsten Hochzeitsfilme der Filmgeschichte.",
          "Tommaso und Stefania wollen heiraten. Aber sind sie für ihr zukünftiges Glück wirklich allein verantwortlich? Der Priester Don Livio hat da so seine Zweifel. Wie ein moderner Don Camillo inszeniert er eine Hochzeit, die allen Erwartungen widerspricht und sich mehr um die Gäste als das Paar zu kümmern scheint. Denn sind nicht sie es, die für das Gelingen oder Scheitern dieser zukünftigen Ehe verantwortlich sind?",
          "Bei allen geistreichen und humoristischen Wendungen, die dieser Film im Verlauf immer wieder nimmt, behandelt er mit Leichtigkeit ein existenzielles Thema unserer modernen Zeit: Beziehungsfähigkeit, Verantwortung für sich und den anderen und das Wahrnehmen der leisen Töne in einer immer „lauter“ werdenden Welt.",
          "Beim Filmfestival „Cinema! Italia 2003” erhielt dieser Film nicht nur bundesweit den Publikumspreis: er war auch der Favorit des Düsseldorfer Publikums."
        ],
        "image": "../casomai.jpg"
      }
    ]
  },
  {
    "title": "2004 - La Gabbianella e il Gatto (Wie Kater Zorbas der kleinen Möwe das Fliegen beibrachte)",
    "subtitle": [""],
    "bodycopy": [
      "Zeichentrickfilm für Kinder, gezeichnet vom Regisseur und Drehbuchschreiber Enzo D'Alò, gezeigt vom Filmmuseum Düsseldorfs, der BLACK BOX - das Kino im Filmmuseum - mit Unterstützung durch Manzin italienische Übersetzungen anläßlich des italienischen Festes zum „Tag der Republik“."
    ],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "La Gabbianella e il Gatto (Wie Kater Zorbas der kleinen Möwe das Fliegen beibrachte)",
        "director": "Enzo D'Alò",
        "country": "Italien",
        "releaseYear": 1999,
        "runtime": 78,
        "version": "OF",
        "screeningDate": "29.05.2004",
        "readableDate": "2004-05-29",
        "screeningTime": "15:00",
        "actors": "Regisseur, Drehbuchschreiber und Zeichner: Enzo D'Alò",
        "subtitle": [""],
        "bodycopy": [
          "Kengah, einer im Sterben liegenden ölverschmierten Möwe, gelingt es, Ihr Ei dem Kater Zorbas anzuvertrauen und ihm drei Bedingungen abzuringen:",
          "Er wird das Ei nicht essen. Er wird es pflegen und hüten bis es sich öffnet. Er wird dem Neugeborenen das Fliegen beibringen",
          "Die verwaiste Möwe erhält von der ganzen Katzengemeinschaft den Namen Fortunata. Die Kleine wird sich kennenlernen müssen und begreifen, dass sie keine Katze ist, um das Fliegen lernen zu können."
        ],
        "image": "../gabianellagatto.jpg"
      }
    ]
  },
  {
    "title": "2004 - Il mestiere delle armi (Der Medici Krieger)",
    "subtitle": [""],
    "bodycopy": ["Jahr Null für den italienischen Filmclub“."],
    "links": [
      {
        "label": "",
        "link": ""
      }
    ],
    "movies": [
      {
        "title": "Il mestiere delle armi (Der Medici krieger)",
        "director": "Ermanno Olmi",
        "country": "Italien/Frankreich/Deutschland",
        "releaseYear": 2001,
        "runtime": 105,
        "version": "OmU",
        "screeningDate": "06.12.2003",
        "readableDate": "2003-12-06",
        "screeningTime": "19:30",
        "actors": "Hristo Jivkov, Sergio Grammatico, Fabio Giubbani, Sandra Ceccarelli, Dessy Tenekedjieva, Dimitar Ratchkov",
        "subtitle": [""],
        "bodycopy": [
          "Winter 1526. Italien wird durch ein gewaltiges Heer bedroht. Kaiser Karl V. entsandte seine Landsknechte unter Führung des Generals Georg von Frundsberg nach Italien, um den mit Frankreich verbündeten Kirchenstaat anzugreifen. Die Päpstlichen Truppen unter ihrem Befehlshaber Generale della Rovere stellen sich den Kaiserlichen entgegen, allen voran der militärisch brillante Capitano der gefürchteten Schwarzen Banden: Giovanni de’ Medici",
          "Der Film beginnt mit seiner Aufbahrung und faltet rückblickend seine Geschichte auf, in der Heldenmut und moderne Kriegstechnik konkurrieren. Olmi hat keinen gewöhnlichen Historienfilm geschaffen, sondern einen Ablauf archaischer, ruhiger, zum Teil meditativer Bilder, in der das Menschliche in den Vordergrund rückt. Der Film wurde mit 9 „Donatellos“ (italienische „Oscars“) ausgezeichnet."
        ],
        "image": "../ilmestieredelle armi.jpg"
      }
    ]
  }
]
